import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedNetworkRequest {
  selectedNetworkRequest: any[];
  selectedNetworkIndex: number;
}

const initialState: SelectedNetworkRequest = {
  selectedNetworkRequest: [],
  selectedNetworkIndex: 0,
};

const selectedNetworkRequestSlice = createSlice({
  name: 'selectedNetworkRequest',
  initialState,
  reducers: {
    setSelectedNetworkRequest(state, action: PayloadAction<any[]>) {
      state.selectedNetworkRequest = action.payload;
    },
    updateSelectedNetworkRequest(state, action: PayloadAction<any>) {
      const index = action.payload.index;
      delete action.payload.index;
      state.selectedNetworkRequest[index] = {
        ...state.selectedNetworkRequest[index],
        ...action.payload,
      };
    },
    resetSelectedNetworkRequest() {
      return { ...initialState };
    },
    setSelectedNetworkIndex(state, action: PayloadAction<number>) {
      state.selectedNetworkIndex = action.payload;
    },
    incrementSelectedNetworkIndex(state) {
      state.selectedNetworkIndex += 1;
    },
  },
});

export const {
  setSelectedNetworkRequest,
  updateSelectedNetworkRequest,
  resetSelectedNetworkRequest,
  setSelectedNetworkIndex,
  incrementSelectedNetworkIndex,
} = selectedNetworkRequestSlice.actions;

export default selectedNetworkRequestSlice.reducer;
